import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon"

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';


export class PageTitle extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuOpen: false,
            menuAnchor:null
        };
    }

    openMenu = (bool, e = null) => {
        if (e) {
            this.setState({ menuOpen: bool, menuAnchor: e.currentTarget });
            return
        }

        this.setState({ menuOpen: bool });
    }

    render() {

        return (
            <MDBox py={2} container>
                <Grid container justifyContent={"space-between"}>
                    <Grid item>
                        <MDTypography
                            variant={"h2"}
                            textTransform={"uppercase"}
                            verticalAlign={"middle"}
                            style={{ display: "flex", alignItems: "center" }}
                        >
                            {this.props.backButton ?
                                <Icon fontSize={"large"} style={{ marginRight: 15, cursor: "pointer" }} onClick={() => this.props.backButton()}>chevron_left</Icon>
                                : null
                            }
                            {this.props.text}
                            {this.props.icon ?
                                <Icon fontSize={"large"} style={{ marginLeft: 15 }}>{this.props.icon}</Icon>
                                : null
                            }
                        </MDTypography>
                    </Grid>

                    {this.props.menu.length>0 ?
                        <Grid item>
                            <Icon fontSize={"large"} onClick={(e) => this.openMenu(true, e)} sx={{cursor:"pointer"}}>menu</Icon>
                            <Menu
                                id="basic-menu"
                                open={this.state.menuOpen}
                                anchorEl={this.state.menuAnchor}
                                onClose={()=>this.openMenu(false)}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                            >
                                {this.props.menu.map((el, index) => {
                                    return (
                                        <MenuItem key={"pagetitle-menu-" + index} onClick={() => { el.function();this.openMenu(false) }}>{el.label}</MenuItem>
                                        )
                                })}
                            </Menu>

                        </Grid>
                        : null
                    }
                </Grid>


                {this.props.subtitle ?
                    <MDTypography
                        variant={"caption"}
                        textTransform={"uppercase"}
                        verticalAlign={"middle"}
                        style={{ display: "flex", alignItems: "center" }}
                    >
                        {this.props.subtitle}
                    </MDTypography>
                    : null}
            </MDBox>
        )
    }
}

export default PageTitle;


PageTitle.defaultProps = {
    text: "testo",
    subtitle:null,
    icona: null,
    menu: [],
}
